import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';

export const useReloadReceipt = (receiptId: string) => {
  const { projectId } = useParams();
  const queryClient = useQueryClient();

  return useMutation<void, Error>({
    mutationFn: () => apiClient.put(`/v1/projects/${projectId}/receipts/${receiptId}/reload`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['receipts', projectId] });
      queryClient.invalidateQueries({ queryKey: ['receipt', receiptId] });
    },
  });
};
